import { render, staticRenderFns } from "./items-in-all.vue?vue&type=template&id=3aa62b1d"
import script from "./items-in-all.vue?vue&type=script&lang=js"
export * from "./items-in-all.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports